module.exports = __webpack_public_path__ + "img/lock-icon.ee9a3969.svg";